<template>
  <v-layout style="max-width: 180px">
    <v-btn small color="error" outline @click="dialog = true">
      <v-icon left>mdi-undo</v-icon>
      Desfazer Análise
    </v-btn>

    <v-dialog
      v-model="dialog"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">Atencão</v-card-title>

        <v-card-text>
          Ao realizar essa ação, o status do Documento passará para
          'Aguardando Análise' e não poderá ser desfeita
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="red darken-1"
            flat
            @click="dialog = false"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="primary"
            flat
            @click="undoAnalysis()"
          >
            Continuar
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'UndoAnalysisComponent',
  props: ['document', 'application'],
  components: {},
  data() {
    return {
      dialog: false,
      isUploading: false,
    };
  },
  methods: {
    undoAnalysis() {
      this.$store.dispatch('setLoadingDialog', true);
      this.$store.dispatch('undoAnalysis', {
        document: this.document,
        application: this.application,
      }).then(() => {
        this.$store.dispatch('setLoadingDialog', false);
        this.dialog = false;
      });
    },
  },
};
</script>

<style scoped="true">
  .text-justfy {
    text-align: justify;
  }
</style>
